var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data"},[_c('div',[_c('p',[_vm._v("959")]),_c('p',[_vm._v("unique"),_c('br'),_vm._v("punks")])]),_c('div',[_c('p',[_vm._v("40")]),_c('p',[_vm._v("super rare"),_c('br'),_vm._v("punks")])]),_c('div',[_c('p',[_vm._v("1")]),_c('p',[_vm._v("ultra rare"),_c('br'),_vm._v("punk")])])])
}]

export { render, staticRenderFns }